<mat-card>
  <div class="title-row">
    <mat-card-title class="small-title">{{ viewMode ? 'Composer Details' : 'Edit Composer' }}</mat-card-title>
    <button *ngIf="viewMode" mat-button class="close-top-btn" type="button" (click)="closeDialog()">Close</button>
  </div>
  <mat-card-content>
    <form *ngIf="!viewMode" [formGroup]="editForm">
      <!-- Surname and Full Name on the same row -->
      <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Surname</mat-label>
          <input matInput formControlName="surname">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 3;">
          <mat-label>Full Name</mat-label>
          <input matInput formControlName="fullName">
        </mat-form-field>
      </div>

      <!-- Year of Birth, Year of Death, Country of Birth, and Resource Folder on the same row -->
  <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Year of Birth</mat-label>
          <input matInput type="number" formControlName="yearOfBirth">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Year of Death</mat-label>
          <input matInput type="number" formControlName="yearOfDeath">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Country of Birth</mat-label>
          <input matInput formControlName="countryOfBirth">
        </mat-form-field>
      </div>

      <!-- Short Description on its own row -->
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Short Description</mat-label>
        <textarea matInput formControlName="descriptionShort"></textarea>
      </mat-form-field>

      <!-- Long Description on its own row -->
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Long Description</mat-label>
        <textarea matInput formControlName="descriptionLong" rows="5"></textarea>
      </mat-form-field>
    </form>

    <div *ngIf="viewMode" class="view-mode">
      <p *ngIf="(data.composer?.surname || '').trim().length > 0"><strong>Surname:</strong> {{ data.composer?.surname }}</p>
      <p *ngIf="(data.composer?.fullName || '').trim().length > 0"><strong>Full Name:</strong> {{ data.composer?.fullName }}</p>
      <p *ngIf="(data.composer?.countryOfBirth || '').trim().length > 0"><strong>Country of Birth:</strong> {{ data.composer?.countryOfBirth }}</p>
      <p *ngIf="data.composer?.yearOfBirth !== null && data.composer?.yearOfBirth !== undefined"><strong>Year of Birth:</strong> {{ data.composer?.yearOfBirth }}</p>
      <p *ngIf="data.composer?.yearOfDeath !== null && data.composer?.yearOfDeath !== undefined"><strong>Year of Death:</strong> {{ data.composer?.yearOfDeath }}</p>
      <p *ngIf="(data.composer?.descriptionShort || '').trim().length > 0"><strong>Short Description:</strong> {{ data.composer?.descriptionShort }}</p>
      <!-- Collapsible Long Description -->
      <div *ngIf="(data.composer?.descriptionLong || '').trim().length > 0" class="collapsible">
        <p class="collapsible-header" (click)="toggleLongDesc()">
          <strong>Long Description</strong>
          <span class="chevron">{{ showLongDesc ? '▲' : '▼' }}</span>
        </p>
        <p *ngIf="showLongDesc" class="collapsible-content">{{ data.composer?.descriptionLong }}</p>
      </div>
      <!-- Resource Folder intentionally hidden in view mode -->
    </div>
  </mat-card-content>

  <!-- Composer Resources Subcomponent -->
  <mat-divider></mat-divider>
  <mat-card-content class="resources-section">
    <app-resource-composer 
      [composerId]="data.composer?.id ?? 0" 
      [viewMode]="viewMode" 
      [resourceFolder]="data.composer?.resourceFolder || ''">
    </app-resource-composer>
  </mat-card-content>

  <!-- Buttons at the bottom (render only in edit mode) -->
  <mat-card-actions *ngIf="!viewMode">
    <div class="form-actions">
      <button mat-raised-button color="primary" type="button" (click)="saveChanges()">Save</button>
      <button mat-raised-button color="warn" type="button" (click)="closeDialog()">Cancel</button>
    </div>
  </mat-card-actions>
</mat-card>


